import { useState } from "react";

const LinkResearcher = () => {
  // Dummy researchers
  const researchers = [
    { id: 1, name: "Dr. Ayesha Khan", email: "ayesha.khan@example.com" },
    { id: 2, name: "Dr. Bilal Shah", email: "bilal.shah@example.com" },
    { id: 3, name: "Dr. Fatima Riaz", email: "fatima.riaz@example.com" },
  ];

  const [selectedResearcher, setSelectedResearcher] = useState("");

  return (
    <div className="mt-6 p-4 bg-white shadow rounded max-w-md mx-auto">
      <h2 className="text-xl font-bold mb-4">Select Researcher to Link</h2>

      {/* Researcher Select */}
      <select
        value={selectedResearcher}
        onChange={(e) => setSelectedResearcher(e.target.value)}
        className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="">-- Select Researcher --</option>
        {researchers.map((researcher) => (
          <option key={researcher.id} value={researcher.id}>
            {researcher.name} ({researcher.email})
          </option>
        ))}
      </select>

      {/* Show button only if a researcher is selected */}
      {selectedResearcher && (
        <button
          className="mt-4 w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition"
        >
          Link Researcher
        </button>
      )}
    </div>
  );
};

export default LinkResearcher;
